
import { Vue, Component, Emit, Prop } from "vue-property-decorator";
import MapApp from "@/plugin/gis-viewer/MapAppPGIS";
import {
  IMapContainer,
  IOverlayParameter,
  IHeatParameter,
  IOverlayClusterParameter,
  IOverlayDelete,
  ILayerConfig,
  IPointGeometry,
  ICenterLevel,
  IFindParameter,
  IResult,
  IDistrictParameter,
  IStreetParameter,
  IRouteParameter,
  IHeatImageParameter,
  IGeometrySearchParameter,
  ICustomTip,
  ISelectRouteParam,
  ISelectRouteResult,
  IDrawOverlays,
  ISelectRouteHitTest,
  IDefinitionParameter,
  ITrackParameter,
  IPassagewaysParam,
  ISumoConnectInfo,
  ISignalPhaseInfo,
  IPopUpTemplate,
} from "@/types/map";
@Component({
  name: "MapContainerPGIS_LS",
})
export default class MapContainerPGIS_LS extends Vue implements IMapContainer {
  private mapApp!: MapApp;
  private mapId: string = "divPGISMap" + (Math.random() * 10000).toFixed(0);
  @Prop({ type: Object }) readonly mapConfig!: Object;

  @Emit("map-loaded")
  async mounted() {
    this.mapApp = new MapApp();
    await this.mapApp.initialize(this.mapConfig, this.mapId);
    this.mapApp.mapClick = this.mapClick;
    this.mapApp.showGisDeviceInfo = this.showGisDeviceInfo;
  }
  @Emit("map-click")
  public mapClick(point: object) {}
  @Emit("draw-complete")
  public drawCallback(result: any) {}
  @Emit("marker-click")
  public showGisDeviceInfo(type: string, id: string, detail: any) {}

  public async addOverlays(params: IOverlayParameter): Promise<IResult> {
    return await this.mapApp.addOverlays(params);
  }
  public async addOverlaysCluster(
    params: IOverlayClusterParameter
  ): Promise<IResult> {
    return { status: 0, message: "" };
  }
  public async addHeatMap(params: IHeatParameter): Promise<IResult> {
    return this.mapApp.addHeatMap(params);
  }
  public deleteOverlays(params: IOverlayDelete): Promise<IResult> {
    return this.mapApp.deleteOverlays(params);
  }
  public deleteOverlaysCluster(params: IOverlayDelete) {
    this.mapApp.deleteOverlaysCluster(params);
  }
  public deleteAllOverlays() {
    this.mapApp.deleteAllOverlays();
  }
  public deleteAllOverlaysCluster() {
    this.mapApp.deleteAllOverlaysCluster();
  }
  public deleteHeatMap(params: ILayerConfig) {
    this.mapApp.deleteHeatMap(params);
  }
  public showLayer(params: ILayerConfig) {
    this.mapApp.showLayer(params);
  }
  public hideLayer(params: ILayerConfig) {
    this.mapApp.hideLayer(params);
  }
  public setMapCenter(params: IPointGeometry) {
    this.mapApp.setMapCenter(params);
  }
  public async setMapCenterAndLevel(params: ICenterLevel): Promise<void> {
    this.mapApp.setMapCenterAndLevel(params);
  }
  public showJurisdiction() {
    this.mapApp.showJurisdiction();
  }
  public hideJurisdiction() {
    this.mapApp.hideJurisdiction();
  }
  public showDistrictMask(param: IDistrictParameter) {}
  public hideDistrictMask() {}
  public findFeature(params: IFindParameter): Promise<IResult> {
    return this.mapApp.findFeature(params);
  }
  public showRoad() {}
  public hideRoad() {}
  public showStreet() {}
  public hideStreet() {}
  public locateStreet(param: IStreetParameter) {}
  public setMapStyle(param: string) {
    this.mapApp.setMapStyle(param);
  }
  public async routeSearch(params: IRouteParameter): Promise<IResult> {
    return { status: 0, message: "" };
  }
  public clearRouteSearch() {}
  public showRoutePoint(params: any) {}
  public clearRoutePoint() {}
  public async addDrawLayer(params: any): Promise<IResult> {
    return { status: 0, message: "" };
  }
  public clearDrawLayer(params: ILayerConfig) {}
  public addHeatImage(params: IHeatImageParameter) {}
  public deleteHeatImage() {}
  public showMigrateChart(params: any) {}
  public hideMigrateChart() {}
  public showBarChart(params: any) {}
  public hideBarChart() {}

  public async startGeometrySearch(
    params: IGeometrySearchParameter
  ): Promise<IResult> {
    return this.mapApp.startGeometrySearch(params);
  }
  public clearGeometrySearch() {
    return this.mapApp.clearGeometrySearch();
  }

  public async showDgene(params: any): Promise<IResult> {
    return { status: 0, message: "" };
  }
  public hideDgene() {}
  public async addDgeneFusion(params: any): Promise<IResult> {
    return { status: 0, message: "" };
  }
  public async restoreDegeneFsion(): Promise<IResult> {
    return { status: 0, message: "" };
  }
  public showCustomTip(params: ICustomTip) {}
  public showDgeneOutPoint(params: any) {}
  public changeDgeneOut() {}

  public async initializeRouteSelect(params: ISelectRouteParam) {}
  public async showSelectedRoute(params: ISelectRouteResult) {}
  public async playSelectedRoute(speed: number) {}
  public stopPlaySelectedRoute() {}
  public async routeHitArea(params: ISelectRouteHitTest): Promise<IResult> {
    return { status: -1, message: "" };
  }
  public async areaHitRoute(params: ISelectRouteHitTest): Promise<IResult> {
    return { status: -1, message: "" };
  }

  public async startDrawOverlays(params: IDrawOverlays): Promise<void> {
    this.mapApp.drawCallback = this.drawCallback;
    return await this.mapApp.startDrawOverlays(params);
  }
  public async stopDrawOverlays(): Promise<void> {
    return await this.mapApp.stopDrawOverlays();
  }
  public async deleteDrawOverlays(params: IOverlayDelete): Promise<void> {
    return await this.mapApp.deleteDrawOverlays(params);
  }
  public async getDrawOverlays(): Promise<IResult> {
    return await this.mapApp.getDrawOverlays();
  }

  public async startLayerSearch(
    params: IGeometrySearchParameter
  ): Promise<IResult> {
    return { status: 0, message: "" };
  }
  public async startLayerDefinition(
    params: IDefinitionParameter
  ): Promise<void> {}
  public async startTrackPlay(params: ITrackParameter): Promise<void> {}

  public async showOverlays(params: IOverlayDelete): Promise<IResult> {
    return await this.mapApp.showOverlays(params);
  }

  public async hideOverlays(params: IOverlayDelete): Promise<IResult> {
    return await this.mapApp.hideOverlays(params);
  }

  public async getOverlays(params: IOverlayDelete): Promise<IResult> {
    return await this.mapApp.getOverlays(params);
  }

  public async getRegionOverlays(params: IOverlayParameter): Promise<IResult> {
    return { status: 0, message: "" };
  }

  public async addAnimatePoints(params: IOverlayParameter): Promise<IResult> {
    return { status: -2, message: "no function" };
  }
  public async deleteAnimatePoints(params?: IOverlayDelete): Promise<IResult> {
    return { status: -2, message: "no function" };
  }
  public async startSignalPhase(params: ISignalPhaseInfo): Promise<IResult> {
    return { status: -2, message: "no function" };
  }
  public async showPopup(params: IPopUpTemplate) {}
  public async closePopup() {
    this.mapApp.closePopup();
  }
  public toggleWidget(params: string[]) {
    this.mapApp.toggleWidget(params);
  }
}
